module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp1_9016.c89b39d7.png";